import { usePortcallStore } from '@/store/portcallStore';
import { getProforma } from '@/services/api/api-calls/getProforma';
import { getVessel } from '@/services/api/api-calls/getVessel';
import { getClient } from '@/services/api/api-calls/getClient';

const getLocationDetail = async (locationId: string | number, location: string) => {
  if (location === 'proforma') {
    const proformaWindow = await getProforma(locationId);
    return proformaWindow?.proformaInfo;
  }
  if (location === 'portcall') {
    const portcallStore = usePortcallStore();
    return portcallStore.callDetails;
  }
  if (location === 'vessel') {
    const vessel = await getVessel(locationId);
    return vessel;
  }
  if (location === 'client') {
    const client = await getClient(locationId);
    return client;
  }
  return null;
}

export default getLocationDetail;
